/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { LocationPinIcon16Light } from './LocationPinIcon16Light';
import { LocationPinIcon16Regular } from './LocationPinIcon16Regular';
import { LocationPinIcon16Solid } from './LocationPinIcon16Solid';
import { LocationPinIcon20Light } from './LocationPinIcon20Light';
import { LocationPinIcon20Regular } from './LocationPinIcon20Regular';
import { LocationPinIcon20Solid } from './LocationPinIcon20Solid';
import { LocationPinIcon24Regular } from './LocationPinIcon24Regular';
import { LocationPinIcon24Solid } from './LocationPinIcon24Solid';
import { LocationPinIcon32Regular } from './LocationPinIcon32Regular';
import { LocationPinIcon64Regular } from './LocationPinIcon64Regular';
var sizes = {
    16: {
        light: LocationPinIcon16Light,
        regular: LocationPinIcon16Regular,
        solid: LocationPinIcon16Solid,
    },
    20: {
        light: LocationPinIcon20Light,
        regular: LocationPinIcon20Regular,
        solid: LocationPinIcon20Solid,
    },
    24: {
        regular: LocationPinIcon24Regular,
        solid: LocationPinIcon24Solid,
    },
    32: {
        regular: LocationPinIcon32Regular,
    },
    64: {
        regular: LocationPinIcon64Regular,
    },
};
export var LocationPinIcon = forwardRef('LocationPinIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
